import React, { useState } from "react";

/**
 * <SmartImg> — image with skeleton/blur placeholder that fades in on load.
 *
 * Props:
 *   - src, alt: standard <img> props
 *   - className: applied to the wrapper (needs aspect / sizing)
 *   - imgClassName: applied to the <img> element itself
 *   - rounded: default rounded classes if not provided in className
 *   - testId: forwarded to wrapper
 */
export default function SmartImg({
  src,
  alt = "",
  className = "",
  imgClassName = "",
  testId,
  loading = "lazy",
  ...rest
}) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  return (
    <div
      className={`relative overflow-hidden bg-neutral-100 ${className}`}
      data-testid={testId}
    >
      {/* Shimmer skeleton */}
      {!loaded && !errored && (
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-gradient-to-r from-neutral-100 via-neutral-200 to-neutral-100 bg-[length:200%_100%] animate-[shimmer_1.4s_ease-in-out_infinite]"
          style={{ animationName: "shimmer" }}
        />
      )}
      {errored && (
        <div
          aria-hidden="true"
          className="absolute inset-0 flex items-center justify-center text-neutral-400 text-xs"
        >
          image unavailable
        </div>
      )}
      <img
        src={src}
        alt={alt}
        loading={loading}
        onLoad={() => setLoaded(true)}
        onError={() => setErrored(true)}
        className={`h-full w-full object-cover transition-opacity duration-500 ${
          loaded ? "opacity-100" : "opacity-0"
        } ${imgClassName}`}
        {...rest}
      />
    </div>
  );
}
